<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    @close="dialogClose"
  >
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />
    <p class="p1">{{ $t("password_recovery.update_password") }}</p>
    <el-form
      class="mt20"
      :model="formData"
      :rules="rules"
      ref="ruleFormModifyPWD"
    >
      <el-form-item
        :label="$t('password_recovery.old_password')"
        prop="oldPassword"
      >
        <el-input
          v-model="formData.oldPassword"
          :type="showPassword ? '' : 'password'"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        >
          <template slot="suffix">
            <img
              v-if="!showPassword"
              @click="showPassword = !showPassword"
              class="eye-img"
              src="@/assets/img/images/icon/eye1.png"
            />
            <img
              v-if="showPassword"
              @click="showPassword = !showPassword"
              class="eye-img"
              src="@/assets/img/images/icon/eye2.png"
            />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        :label="$t('password_recovery.new_password')"
        prop="password"
      >
        <el-input
          v-model="formData.password"
          :type="showPassword1 ? '' : 'password'"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        >
          <template slot="suffix">
            <img
              v-if="!showPassword1"
              @click="showPassword1 = !showPassword1"
              class="eye-img"
              src="@/assets/img/images/icon/eye1.png"
            />
            <img
              v-if="showPassword1"
              @click="showPassword1 = !showPassword1"
              class="eye-img"
              src="@/assets/img/images/icon/eye2.png"
            />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        :label="$t('password_modify.password_confirm')"
        prop="passwordConfirm"
      >
        <el-input
          v-model="formData.passwordConfirm"
          :type="showPassword2 ? '' : 'password'"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        >
          <template slot="suffix">
            <img
              v-if="!showPassword2"
              @click="showPassword2 = !showPassword2"
              class="eye-img"
              src="@/assets/img/images/icon/eye1.png"
            />
            <img
              v-if="showPassword2"
              @click="showPassword2 = !showPassword2"
              class="eye-img"
              src="@/assets/img/images/icon/eye2.png"
            />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="user.phoneSecurity === 1"
        :label="$t('password_modify.mes_code')"
        prop="phoneCode"
      >
        <el-input
          v-model="formData.phoneCode"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        >
          <template slot="append"
            ><span v-if="!phoneCodeStatus.hasSend" @click="hasSendPhoneCode">
              {{ $t("password_modify.getCode") }}</span
            >
            <span v-else>{{ phoneCodeStatus.times }}</span></template
          >
        </el-input>
      </el-form-item>

      <el-form-item
        v-if="user.emailSecurity === 1"
        :label="$t('password_modify.email_code')"
        prop="emailCode"
      >
        <el-input
          v-model="formData.emailCode"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        >
          <template slot="append"
            ><span v-if="!emailCodeStatus.hasSend" @click="hasSendEmailCode">
              {{ $t("password_modify.getCode") }}</span
            >
            <span v-else>{{ emailCodeStatus.times }}</span></template
          >
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="user.googleSecurity === 1"
        :label="$t('password_modify.google_code')"
        prop="googleCode"
      >
        <el-input
          v-model="formData.googleCode"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        />
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <div class="btn2" @click="submit">{{ $t("buy_box.confirm") }}</div>
    </div>
  </el-dialog>
</template>

<script>
import bus from "@/assets/js/bus";
import { mapState } from "vuex";
export default {
  data() {
    let passwordConfirmValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("validate.password_confirm_again")));
      } else if (value !== this.formData.password) {
        callback(new Error(this.$t("validate.password_confirm_error")));
      } else {
        callback();
      }
    };
    return {
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      dialogVisible: false,

      formData: {
        emailCode: "",
        emailToken: "",
        oldPassword: "",
        password: "",
        passwordConfirm: "",
        phoneCode: "",
        phoneToken: "",
        googleCode: "",
      },
      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      emailCodeStatus: {
        hasSend: false,
        times: 60,
      },
      rules: {
        phoneCode: [
          {
            required: true,
            message: this.$t("validate.mes_code_require"),
            trigger: "blur",
          },
        ],
        emailCode: [
          {
            required: true,
            message: this.$t("validate.email_code_require"),
            trigger: "blur",
          },
        ],
        oldPassword: [
          {
            required: true,
            message: this.$t("validate.password_require"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("validate.password_require"),
            trigger: "blur",
          },
          {
            pattern: bus.regs.loginPWD,
            message: this.$t("validate.password_formatter_tip"),
            trigger: "blur",
          },
        ],
        passwordConfirm: [
          { validator: passwordConfirmValidate, trigger: "blur" },
        ],
        googleCode: [
          {
            required: true,
            message: this.$t("validate.google_code_require"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  methods: {
    hasSendPhoneCode() {
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/user/sendUpdatePwdPhoneCode", { phone: this.phone })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.formData.phoneToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    hasSendEmailCode() {
      this.emailCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.emailCodeStatus.times <= 0) {
          this.emailCodeStatus.hasSend = false;
          this.emailCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.emailCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/user/sendUpdatePwdEmailCode", { email: this.email })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.formData.emailToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    submit() {
      this.$refs.ruleFormModifyPWD.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.$axios
            .post("/user/changeLoginPwd", this.formData)
            .then((res) => {
              if (res.data.code === this.errorCode.ok) {
                window.localStorage.removeItem("jwt-token");
                this.elMessage("success", this.$t("password_modify.success"));
                this.$store.dispatch("actions_loginOut").then((res) => {
                  this.$router.push({ path: "/login" });
                });
              } else {
                this.elMessage("error", res.data.msg);
              }
            });
        }
      });
    },
    dialogClose() {
      this.$refs.ruleFormModifyPWD.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 540px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
  .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .el-input__suffix,
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input-group--append {
    gap: 16px;
    display: flex;
  }
  .el-input__inner {
    height: 60px;
    border-radius: 8px 8px 8px 8px;
  }
  .el-input-group__append {
    cursor: pointer;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #4063ff;
    padding: 0 24px;
    width: auto;
    display: flex;
    align-items: center;
  }
  .el-form-item {
    margin-bottom: 8px;
  }
}
.mt8 {
  margin-top: 8px;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #f04545;
}

.box1 {
  width: 480px;
  height: 160px;
  overflow: hidden;
  padding-left: 20px;
  background: #ffffff;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px 12px 12px 12px;
  background-image: url(~@/assets/img/images/member-bj.png);
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}

.eye-img {
  width: 25px;
  height: 25px;
  cursor: pointer;
  margin-right: 6px;
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #4063ff;
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: #3370ff;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
  }
}
</style>
